import gql from 'graphql-tag';
import produce from 'immer';
import { updateListFilterQueryString } from './updateQueryString';
import qs from 'qs';
// QUERY
export const isListFilterActive = function isListFilterActive(parent) {
    return (searchParams) => {
        var _a, _b, _c, _d;
        const query = __IN_SERVER__ ? searchParams : document.location.search;
        // e.g. Armchair:product-type:151
        const [, name, category] = parent.id.split(':');
        // Get the list filters from the search params
        // e.g.
        // {
        //// "151:product-type": ["Armchair"]
        // }
        const paramFilter = qs.parse(query, {
            ignoreQueryPrefix: true
        });
        if (!paramFilter)
            return false;
        // Key contains category on category pages, but not on search results
        const key = category ? `${category}:${name}` : name;
        // ListFilterItem may be part of a list or a multiList
        const filterType = ((_a = paramFilter.list) === null || _a === void 0 ? void 0 : _a[key]) || ((_b = paramFilter.multiList) === null || _b === void 0 ? void 0 : _b[key]);
        // If the params have a matching key and that key has an array including the
        // value of this list filter item, then this list filter item is active
        return _d = (_c = filterType) === null || _c === void 0 ? void 0 : _c.includes(parent.value), (_d !== null && _d !== void 0 ? _d : false);
    };
};
////////////////////////////////////////////////////////////////////////////////
// MUTATIONS
export const toggleListFilterItem = function toggleListFilterItem(_, { value, parentId, set }, { cache, getCacheKey }) {
    const fragmentId = getCacheKey({
        id: parentId,
        __typename: 'ListFilter'
    });
    const listItem = cache.readFragment({
        fragment: gql `
      fragment listFilter on ListFilter {
        hasActiveItems @client
        id
        items {
          id
          value
          isActive @client
        }
      }
    `,
        id: fragmentId
    });
    const data = produce(listItem, draft => {
        const { items } = draft;
        // Find the item matching the value passed in as an arg
        const item = items.find(item => item.value === value);
        // If `set` was passed, set the active state to it. Otherwise, toggle
        item.isActive = typeof set === 'boolean' ? set : !item.isActive;
        // If there are any active items, set hasActiveItems to true on the ListFilter
        draft.hasActiveItems = items.some(item => item.isActive);
    });
    cache.writeData({
        id: fragmentId,
        data
    });
    // Write changes to the active filters list
    const { activeFilters } = updateActiveListFilters(cache, data);
    // Update the query string
    updateListFilterQueryString(activeFilters);
    return data;
};
////////////////////////////////////////////////////////////////////////////////
/**
 * Update the active filters in the cache root.
 * @param cache Apollo Client cache
 * @param data The updated list item
 * @returns All active filters
 */
function updateActiveListFilters(cache, data) {
    const activeListFilterQuery = gql `
    query GetActiveListFilters {
      activeFilters @client {
        listFilters {
          id
          values
        }
      }
    }
  `;
    const currentActiveFilters = cache.readQuery({
        query: activeListFilterQuery
    });
    const activeFilters = produce(currentActiveFilters, draft => {
        // Check if the filter that was just toggled is already in activeFilters
        const existingListFilter = draft.activeFilters.listFilters.find(filter => filter.id === data.id);
        // Get an array of ListFilterItem values
        const activeListFilters = data.items
            .filter(item => item.isActive)
            .map(item => item.value);
        // If there are no active ListFilterItems, remove this ListFilter from ActiveFilters
        if (activeListFilters.length === 0) {
            draft.activeFilters.listFilters = draft.activeFilters.listFilters.filter(listFilter => listFilter.id !== existingListFilter.id);
            return;
        }
        if (existingListFilter) {
            // If the list filter was already active, just update it
            existingListFilter.values = activeListFilters;
        }
        else {
            // Otherwise push it to the list of active filters
            draft.activeFilters.listFilters.push({
                id: data.id,
                values: activeListFilters,
                __typename: 'ListFilterInput'
            });
        }
    });
    cache.writeData({
        data: activeFilters
    });
    return activeFilters;
}
//# sourceMappingURL=listFilterItem.js.map